import React from 'react';
import {useTranslation} from 'react-i18next';
import {CloseIcon, IconButton} from '@phonectas/unifon-ui-kit';
import Portal from 'common/components/Portal';
import AiSparkleIcon from 'common/components/icons/AiSparkleIcon';
import {StyledIconBadge, StyledMessage, StyledNotice, StyledTexts, StyledTitle} from './styled';

interface InnsalgNoticeProps {
	message: string | null;
	onClose: () => void;
}

// Own notice at the top of the screen for innsalg, so the shared toasts are left as they are.
// Stays until closed, a short toast is easy to miss during a call
const InnsalgNotice: React.FC<InnsalgNoticeProps> = ({message, onClose}) => {
	const [t] = useTranslation();
	if (!message) return null;

	return (
		<Portal>
			<StyledNotice role="status">
				<StyledIconBadge>
					<AiSparkleIcon size={20} />
				</StyledIconBadge>
				<StyledTexts>
					<StyledTitle>{t('AI upsell tips')}</StyledTitle>
					<StyledMessage>{message}</StyledMessage>
				</StyledTexts>
				<IconButton onClick={onClose} size="xs" aria-label={t('Close')}>
					<CloseIcon />
				</IconButton>
			</StyledNotice>
		</Portal>
	);
};

export default InnsalgNotice;
